import type { ContentDeviceDiagnostics } from "@teamtable/api";
import type { DeviceDiagnostics } from "@teamtable/content-sdk";

/** New objects keep a bundle from mutating the shell's cached API response. */
export function mapDeviceDiagnostics(
  snapshot?: ContentDeviceDiagnostics,
): DeviceDiagnostics | null {
  if (!snapshot) return null;
  const wifi = snapshot.wifi;
  const speed = snapshot.internet_speed;
  return {
    wifi: wifi
      ? {
          connected: wifi.connected,
          rssiDbm: wifi.rssi_dbm,
          signalLevel: wifi.signal_level,
          linkSpeedMbps: wifi.link_speed_mbps,
          txLinkSpeedMbps: wifi.tx_link_speed_mbps,
          rxLinkSpeedMbps: wifi.rx_link_speed_mbps,
          frequencyMhz: wifi.frequency_mhz,
          updatedAt: snapshot.wifi_updated_at,
        }
      : null,
    temperature:
      snapshot.soc_temp_celsius === undefined
        ? null
        : { socCelsius: snapshot.soc_temp_celsius, updatedAt: snapshot.temperature_updated_at },
    internetSpeed: speed
      ? {
          downloadMbps: speed.download_mbps,
          uploadMbps: speed.upload_mbps,
          testedAt: speed.tested_at,
        }
      : null,
  };
}
